<template>
  <div class="p-front__content">
    <div
      class="p-signup"
      v-if="billingSuccess == false"
      style="margin: 80px 0px;"
    >
      <form
        class="p-signup__form"
        style="width: 80%;"
        method="POST"
        @submit="createBilling"
      >
        <h5 class="p-signup__form-heading">Setup Billing</h5>
        <div class="p-signup__form-content">
          <div class="row">
            <div class="form-group col-md-12">
              <label for="installationId">Installation</label>
              <el-autocomplete
                style="width: 100%;"
                id="customer-contact"
                class="inline-input"
                v-model="regParams.installation"
                :fetch-suggestions="installationSearch"
                placeholder="Search contact"
                prefix-icon="el-icon-search"
                @select="contactSelected"
              ></el-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="price">Amount(NGN)</label>
              <input
                type="number"
                class="form-control form-control-lg"
                id="price"
                v-model="regParams.price"
                placeholder="Amount"
                @change="updateMonthlyCharge"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="numberOfTimesPaymentIsMade"
                >Number of payments made</label
              >
              <input
                type="number"
                class="form-control form-control-lg"
                id="numberOfTimesPaymentIsMade"
                v-model="regParams.numberOfTimesPaymentIsMade"
                placeholder="number of payment times"
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="monthlyRecurringChargeDate">Charge date</label>
              <DatePicker
                v-model="regParams.monthlyRecurringChargeDate"
                id="monthlyRecurringChargeDate"
                class="date-upload"
                placeholder="yyyy-mm-dd"
                :default-value="new Date()"
                :disabled-date="disabledBeforeTodayAndAfterAWeek"
              ></DatePicker>
            </div>
            <div class="form-group col-md-6">
              <label for="duration">Payment Duration (in Months)</label>
              <input
                type="number"
                class="form-control form-control-lg"
                id="duration"
                v-model="regParams.duration"
                placeholder="Monthly Duration"
                @change="updateMonthlyCharge"
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="monthlyCharge">Monthly Charge(NGN)</label>
              <input
                type="number"
                class="form-control form-control-lg"
                id="monthlyCharge"
                v-model="regParams.monthlyCharge"
                disabled
              />
            </div>
          </div>
          <hr />

          <div>
            <button
              type="submit"
              class="btn btn-info btn-block btn-lg p-signup__form-submit"
              @click="createBilling"
            >
              Create Billing
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { Autocomplete, Form, FormItem } from "element-ui";
import DatePicker from "vue2-datepicker";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import moment from "moment";
import { isEmpty } from "element-ui/src/utils/util";

var getSearchParams = k => {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

export default {
  name: "billing-schedule",
  components: {
    DatePicker,
    "el-autocomplete": Autocomplete,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose
  },
  data() {
    return {
      billingSuccess: false,
      regParams: {
        installationId: "",
        duration: "",
        numberOfTimesPaymentIsMade: "",
        monthlyRecurringChargeDate: "",
        price: "",
        monthlyCharge: ""
      },
      errorsResult: {},
      installationList: []
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    updateMonthlyCharge() {
      let calc = this.monthlyCharge;
      calc = this.regParams.price / this.regParams.duration;
      this.regParams.monthlyCharge = Math.ceil(calc).toFixed(2);
    },
    getContacts() {
      const HTTP = this.$httpUtils.instance;
      let ctx = this;
      let filter = {
        where: {
          and: [
            { CID: { neq: null } },
            {
              or: [
                { status: "requested" },
                { status: "scheduled" },
                { status: "commissioned" },
                { status: "completed" }
              ]
            }
          ]
        },
        include: ["deviceRequest", "locations", "user"]
      };
      const url = `/installations?filter=${JSON.stringify(filter)}`;
      HTTP.get(url)
        .then(response => {
          ctx.installationList = response.data.map(x => ({
            ...x,
            value:
              x && x.deviceRequest
                ? `${x.name} (${x.CID ? x.CID : x.solarKitIds}) `
                : null
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "installationId":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Customer's installation ID cannot be empty.";
            }
            break;
          case "duration":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Duration cannot be empty.";
            }
            break;
          case "numberOfTimesPaymentIsMade":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Number of payment made cannot be empty.";
            }
            break;
          case "monthlyRecurringChargeDate":
            if (
              value === "null" ||
              value === "" ||
              isEmpty(value) ||
              value === "Invalid date"
            ) {
              errors[field] = "Charge date cannot be empty.";
            }
            break;
          case "price":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Amount cannot be empty.";
            }
            break;
          case "monthlyCharge":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Monthly charge cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      this.errorsResult = errors;
    },
    createBilling(e) {
      e.preventDefault();
      const keys = Object.keys(this.regParams);
      this.regParams.monthlyRecurringChargeDate = moment(
        this.regParams.monthlyRecurringChargeDate
      ).format();

      this.validateReg();
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      keys.forEach((key, index) => {
        if (!["installation", "monthlyRecurringChargeDate"].includes(key)) {
          this.regParams[key] = parseInt(this.regParams[key]);
        }
      });
      const HTTP = this.$httpUtils.instance;
      const url = "/billings/setup-schedule";
      HTTP.post(url, this.regParams)
        .then(res => {
          console.log("response", res);
          this.showSuccessMsg({ message: "Device setup successfully!" });
          window.history.back();
        })
        .catch(error => {
          console.log("setup error", error.response);
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    installationSearch(queryString, cb) {
      let installationList = this.installationList;
      var results = queryString
        ? installationList.filter(installation =>
            this.createFilter(queryString, installation)
          )
        : installationList;
      cb(results);
    },
    createFilter(queryString, installation) {
      // console.log({ name: installation });
      return (
        `${installation.name} - ${installation.CID}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSelected(installation) {
      let ctx = this;
      let { form } = ctx;
      let { deviceRequest, user, locations } = installation;
      let paymentModel = deviceRequest.paymentModel;
      this.regParams.installationId = installation.id;
    }
  },
  mounted() {},
  created() {
    this.getContacts();
  }
};
</script>

<style scoped>
h4.p-signup__form-heading {
  font-weight: 600;
  color: #6a707e;
  border: none;
}

.date-upload {
  background: transparent;
  border-radius: 3px;
  border: none;
  width: 100%;
  height: 100%;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #727272;
}

#state_dd {
  width: 100%;
}

#state_dd #state_dd__BV_toggle_ {
  width: 100% !important;
}

#reg_success {
  position: absolute;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px;
  z-index: 999;
}

.form-group label {
  color: #424242;
}
.p-signin-a__form-heading {
  margin: 50px 175px;
  border: none;
}
input[type="email"] {
  /* background-image: url("../../assets/img/mail.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}

.p-signup__form-link:last-child {
  margin-bottom: 20px;
}
input[type="text"] {
  /* background-image: url("../../assets/img/profile2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="phone-number"] {
  /* background-image: url("../../assets/img/smartphone-call.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="address"] {
  /* background-image: url("../../assets/img/placeholder.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
select {
  background-color: #ebeff2 !important;
  text-indent: 0px;
}
input[type="password"] {
  /* background-image: url("../../assets/img/key2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="checkbox"] {
  height: 0rem;
  margin-right: 20px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/new-billing.vue